import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { sampleSchemaFieldValue } from './sample-schema-field-value.js'
export function createInputObject(fields: SchemaField[]): Record<string, unknown> {
  return Object.fromEntries(fields.map((field) => [field.name, sampleSchemaFieldValue(field)]))
}
